<div class="mainInfo">
  <h1>{{ title }}</h1>
  <p>{{ subTitle }}</p>
</div>

<div class="msgBlock pt-30">
  <div class="msgBlock__wrapper">
    <div class="msgBlock__content">
      <div class="top bigBottomPad">
        <div class="description">
          <p>{{ description }}</p>
        </div>
        <app-sales-credit-codes-shared
          [otp]="isMexico ? null : otp"
          [contractNumber]="isMexico ? contractNumber : null"
          [personNumber]="isMexico ? personNumber : null">
        </app-sales-credit-codes-shared>
      </div>

      <div class="bottom bottom--trustonic" *ngIf="trustonicAppUrl">
        <div class="bottom__qr">
          <div class="text">
            <p>Usa el siguiente QR para descargar el app:</p>
          </div>
          <div class="qr-code">
            <div class="qr-code__img rounded">
              <qrcode [qrdata]="trustonicAppUrl" [width]="200" [errorCorrectionLevel]="'M'"></qrcode>
            </div>
          </div>
        </div>
        <div class="bottom__separator">
          <div class="separator"><span>O</span></div>
        </div>
        <div class="bottom__link">
          <div class="text">
            <p>Usa este link en tu celular:</p>
          </div>
          <div class="link">
            <a [href]="trustonicAppUrl" target="_blank" rel="nofollow">{{ trustonicAppUrl }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<footer class="pt-30">
  <div class="footer__content">
    <app-phone-app-footer-button-shared [state]="appState" (continueClick)="onContinue()"></app-phone-app-footer-button-shared>
  </div>
</footer>

<app-phone-app-confirmation-modal-shared [visible]="visibleModal" (continueClick)="onContinue()"></app-phone-app-confirmation-modal-shared>
